import { type AppLanguage, appLanguages } from './supported-app-languages-names';

export const supportedAppLanguageCodes: AppLanguage[] = Object.values(appLanguages);

export type LocaleConfig<T> = {
  locale: T;
  name: string;
};
